// Centralized prompts for all Briefr Bullets continent articles
// These match the prompts used in the edge functions

export const BRIEFR_BULLETS_PROMPTS = {
  europa: `Søk på internett etter de fem viktigste eller mest interessante begivenhetene i Europa for kommende uke.

Format:
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere

Eksempel:
• **Overskrift for begivenhet 1**

Beskrivelse her.`,

  afrika: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Afrika den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,

  asia: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Asia den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,

  nordAmerika: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Nord-Amerika den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,

  latinAmerika: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Latin-Amerika den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,

  midtosten: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Midtøsten den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,

  skandinavia: `Søk på internett og finn de fem viktigste og mest interessante begivenhetene som skjer i Skandinavia (Norge, Sverige og Danmark) den kommende uken. Inkluder politikk, samfunn, økonomi, kultur og andre relevante områder.

Formater innholdet NØYAKTIG slik:

• **Overskrift her**

Beskrivelse på 2-3 setninger her med relevant informasjon for norske lesere.

• **Neste overskrift**

Neste beskrivelse.

VIKTIG: 
- IKKE skriv noen innledning
- IKKE inkluder setninger som "Her er noe av det viktigste..." eller "Her er fem viktige..."
- Start DIREKTE med første bullet point (•)
- Bruk bullet points (•) for hver begivenhet
- Skriv overskriften i fet skrift med **overskrift**
- Legg til en tom linje mellom overskrift og beskrivelse
- Skriv 2-3 setninger beskrivelse for hver begivenhet
- Fokuser på nyheter som er relevante for norske lesere`,
} as const;

export const SCHEDULE_INFO = {
  europa: {
    dayOfWeek: 'Mandag',
    time: '05:30',
  },
  afrika: {
    dayOfWeek: 'Torsdag',
    time: '05:30',
  },
  asia: {
    dayOfWeek: 'Onsdag',
    time: '05:30',
  },
  nordAmerika: {
    dayOfWeek: 'Tirsdag',
    time: '05:30',
  },
  latinAmerika: {
    dayOfWeek: 'Fredag',
    time: '05:30',
  },
  midtosten: {
    dayOfWeek: 'Lørdag',
    time: '05:30',
  },
  skandinavia: {
    dayOfWeek: 'Søndag',
    time: '05:30',
  },
} as const;
